module.exports = __webpack_public_path__ + "img/ConfirmationPi.20b321f4.svg";